import diseaseApi from '../api/disease';
import createDataContext from './createDataContext';
import { GLOBAL_COORDS, GLOBAL_IDENTIFIER } from '../utils';
const countriesReducer = (state, action) => {
  switch (action.type) {
    case 'fetch_countries':
      return { ...state, countries: action.payload };
    case 'fetch_global':
      return { ...state, global: action.payload };
    case 'change_country':
      return { ...state, selectedCountry: action.payload };
    default:
      return state;
  }
};

// actions

const fetchCountries = dispatch => async () => {
  const response = await diseaseApi.get('/countries');
  const globalResponse = await diseaseApi.get('/all');
  const globalObj = {
    country: GLOBAL_IDENTIFIER,
    countryInfo: {
      iso2: GLOBAL_IDENTIFIER,
      ...GLOBAL_COORDS
    },
    ...globalResponse.data
  };
  response.data.push(globalObj);
  dispatch({ type: 'fetch_countries', payload: response.data });
};

const setSelectedCountry = dispatch => newCountry => {
  dispatch({ type: 'change_country', payload: newCountry });
};

export const { Context, Provider } = createDataContext(
  countriesReducer,
  { fetchCountries, setSelectedCountry },
  {
    selectedCountry: GLOBAL_IDENTIFIER,
    countries: []
  }
);
